import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Typography, Chip, Stack } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

ComingSoonCard.propTypes = {
  categoryId: PropTypes.string,
  featureId: PropTypes.string,
  variant: PropTypes.oneOf(['feature', 'category']),
};

ComingSoonCard.defaultProps = {
  categoryId: null,
  featureId: null,
  variant: 'feature',
};

export default function ComingSoonCard({ categoryId, featureId, variant }) {
  const { t } = useTranslation();
  const theme = useTheme();

  let label = '';
  if (featureId) {
    label = t(`credits.features.${featureId}`, { defaultValue: featureId });
  } else if (categoryId) {
    label = t(`credits.category.${categoryId}`, { defaultValue: categoryId });
  }

  return (
    <Card
      sx={{
        height: '100%',
        border: '1px dashed',
        borderColor: 'divider',
        bgcolor: alpha(theme.palette.info.main, 0.04),
      }}
    >
      <CardContent>
        <Stack
          spacing={1}
          alignItems="flex-start"
          sx={{
            minHeight: variant === 'category' ? 120 : 'auto',
            justifyContent: variant === 'category' ? 'center' : 'flex-start',
          }}
        >
          <Chip
            label={t('credits.comingSoon')}
            size="small"
            color="info"
            variant="outlined"
          />
          {label && (
            <Typography variant={variant === 'category' ? 'h6' : 'subtitle2'}>
              {label}
            </Typography>
          )}
          <Typography variant="caption" color="text.secondary">
            {t('credits.comingSoonHint')}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
